module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMM7iMP///87iMM14EnYAAAACXRSTlMA3xC/YFDvgECdxfTWAAAAd0lEQVR4Xu3WsQ2EMBAF0UnIyTg5InIF1wENUMNJ14QjXAYhAglpqwS5gP2Zo530v3wXWMztOwPVRB8YTLaSNfpRNLpJGh2YznqhQPubgwK12UGB2uCgQG1wUKA2CBSo89kIlLQ5KRpdZI1GBo02qMr80S/kNPMARhWJsuvCVqgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4f6.png
// module id = 1069
// module chunks = 0